import type { Size } from '../types'

export function EditIcon({ className, size }: { className?: string; size: Size }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.02441 18.9625H6.27441L15.5244 9.71248L14.2994 8.46248L5.02441 17.7375V18.9625ZM18.7244 8.61248L15.3494 5.26248L16.6744 3.96248C16.9577 3.67914 17.3121 3.53748 17.7374 3.53748C18.1621 3.53748 18.5161 3.67914 18.7994 3.96248L20.0244 5.18748C20.3077 5.48748 20.4577 5.84148 20.4744 6.24948C20.4911 6.65814 20.3494 7.00414 20.0494 7.28748L18.7244 8.61248ZM4.42441 20.4625C4.17441 20.4625 3.96208 20.3751 3.78741 20.2005C3.61208 20.0251 3.52441 19.8125 3.52441 19.5625V17.4625C3.52441 17.3458 3.54541 17.2335 3.58741 17.1255C3.62875 17.0168 3.69941 16.9125 3.79941 16.8125L14.2744 6.33748L17.6494 9.71248L7.17441 20.1875C7.07441 20.2875 6.97041 20.3585 6.86241 20.4005C6.75375 20.4418 6.64108 20.4625 6.52441 20.4625H4.42441ZM14.8994 9.08748L14.2994 8.46248L15.5244 9.71248L14.8994 9.08748Z"
        fill="currentColor"
      />
    </svg>
  )
}
